import { EditorAddAudio, EditorAddBot, EditorAddFore, EditorAddImage, EditorAddMultiCharacter, EditorAddSystem, EditorAddTool, EditorAddVideo, SoundEffect, SpineIcon, Video4 } from '@/components/icon';
import { EventToolBarType } from '@/const/mission';

export const EVENT_TOOLBAR_BORDER = 'border';
export interface ToolbarItem {
  label?: string;
  icon?: any;
  key: EventToolBarType | 'border';
  visible?: (isHorizontal: boolean) => boolean;
}

export const eventToolbar = [
  {
    label: '对话',
    icon: <EditorAddBot />,
    key: EventToolBarType.ADD_BOT,
  },
  {
    label: '旁白',
    icon: <EditorAddSystem />,
    key: EventToolBarType.ADD_SYSTEM,
  },
  {
    key: EVENT_TOOLBAR_BORDER,
  },
  {
    label: '单人立绘',
    icon: <EditorAddFore />,
    key: EventToolBarType.ADD_FORE_IMAGE,
  },
  {
    label: '多人立绘',
    icon: <EditorAddMultiCharacter />,
    key: EventToolBarType.ADD_MULTI_CHARACTER,
    visible: (isHorizontal: boolean) => isHorizontal,
  },
  {
    label: 'Spine 立绘',
    icon: <SpineIcon />,
    key: EventToolBarType.ADD_SPINE_FORE_IMAGE,
  },
  {
    key: EVENT_TOOLBAR_BORDER,
  },
  {
    label: '背景图',
    icon: <EditorAddImage />,
    key: EventToolBarType.ADD_BG_IMAGE,
  },
  {
    label: '背景视频',
    icon: <Video4 />,
    key: EventToolBarType.ADD_BG_VIDEO,
  },
  {
    label: '背景音乐',
    icon: <EditorAddAudio />,
    key: EventToolBarType.ADD_AUDIO,
  },
  {
    key: EVENT_TOOLBAR_BORDER,
  },
  {
    label: '视频',
    icon: <EditorAddVideo />,
    key: EventToolBarType.ADD_VIDEO,
  },
  {
    label: '音效',
    icon: <SoundEffect />,
    key: EventToolBarType.ADD_SOUND_EFFECT,
  },
  {
    key: EVENT_TOOLBAR_BORDER,
    visible: (isHorizontal: boolean) => !isHorizontal,
  },
  {
    label: '道具卡',
    icon: <EditorAddTool />,
    key: EventToolBarType.ADD_PROPS,
    visible: (isHorizontal: boolean) => !isHorizontal,
  },
];

// 道具卡
export const propsToolbar = [
  // {
  //   label: '智能填写',
  //   icon: <AutoDrawer />,
  //   key: EventToolBarType.ADD_DRAWER,
  // },
  // {
  //   key: 'border',
  // },
  {
    label: '对话',
    icon: <EditorAddBot />,
    key: EventToolBarType.ADD_BOT,
  },
  {
    label: '旁白',
    icon: <EditorAddSystem />,
    key: EventToolBarType.ADD_SYSTEM,
  },
  {
    key: EVENT_TOOLBAR_BORDER,
  },
  {
    label: '立绘',
    icon: <EditorAddFore />,
    key: EventToolBarType.ADD_FORE_IMAGE,
  },
  {
    label: '背景图',
    icon: <EditorAddImage />,
    key: EventToolBarType.ADD_BG_IMAGE,
  },
  {
    label: '视频',
    icon: <EditorAddVideo />,
    key: EventToolBarType.ADD_VIDEO,
  },
  {
    label: '音效',
    icon: <SoundEffect />,
    key: EventToolBarType.ADD_SOUND_EFFECT,
  },
  {
    label: '背景音乐',
    icon: <EditorAddAudio />,
    key: EventToolBarType.ADD_AUDIO,
  },
];


export const relateToolbar = [
  {
    label: '对话',
    icon: <EditorAddBot />,
    key: EventToolBarType.ADD_BOT,
  },
  // {
  //   label: '引导回复',
  //   icon: <EditorGuideReplay />,
  //   key: EventToolBarType.ADD_GUIDE_REPLAY,
  // },
];


export const relateMainToolbar = [
  {
    label: '对话',
    icon: <EditorAddBot />,
    key: EventToolBarType.ADD_BOT,
  },
];

